import React from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

const AvailableLeave = (props) => {
  const { selectedData } = props;

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  const objectToArray = Object.entries(
    selectedData.userData.availableLeave
  ).map(([label, value]) => ({
    label,
    value,
  }));

  return (
    <div className="addRenderingContainer">
      <Grid item xs={12} sm={12}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{
                    fontWeight: "bold",
                    color: "black",
                    letterSpacing: "1px",
                  }}
                >
                  Leave Type
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontWeight: "bold",
                    color: "black",
                    letterSpacing: "1px",
                  }}
                >
                  Leave Count
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {objectToArray.map((row) => (
                <TableRow
                  key={row.label}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">
                    {capitalizeFirstLetter(row.label)}
                  </TableCell>
                  <TableCell align="left">{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </div>
  );
};

export default AvailableLeave;
